import { render } from "./Display.vue?vue&type=template&id=55f0a2e2"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"

import "./Display.vue?vue&type=style&index=0&id=55f0a2e2&lang=scss"
script.render = render

export default script